import { ERROR_CATEGORIES } from './errorTypes'

export const errorsTrack = []

// Map to group errors by category
export const errorsByCategory = {
  [ERROR_CATEGORIES.API]: [],
  [ERROR_CATEGORIES.UNKNOWN]: []
}

/**
 * Register error by category
 * Note: It doesn't send it to Sentry. This is handled on each compo
 */
export function registerError(error, category = ERROR_CATEGORIES.UNKNOWN, context = {}) {
  // Format error message
  const errorMessage = typeof error === 'string'
    ? error
    : (error.message || 'Unknown error')

  // Add to the original errors array (to keep compatibility)
  if (!errorsTrack.includes(errorMessage)) {
    errorsTrack.push(errorMessage)
  }

  const errorInfo = {
    message: errorMessage,
    component: context.component || 'unknown',
    method: context.method || 'unknown',
    route: context.route || 'unknown',
    timestamp: new Date().toISOString(),
    statusCode: error.response ? error.response.status : null
  }

  // Add to the map of errors by category
  if (category === ERROR_CATEGORIES.API) {
    errorsByCategory[ERROR_CATEGORIES.API].push(errorInfo)
  } else {
    errorsByCategory[ERROR_CATEGORIES.UNKNOWN].push(errorInfo)
  }

  return errorInfo
}
